// RINGOS.BE — Shopify Theme Global JavaScript

document.addEventListener('DOMContentLoaded', function () {
  // ── Mobile Menu Toggle ──────────────────────────────────────────
  const mobileToggle = document.querySelector('.header__mobile-toggle');
  const mobileNav = document.getElementById('mobile-nav');

  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', function () {
      const isOpen = mobileNav.classList.toggle('is-open');
      mobileToggle.setAttribute('aria-expanded', isOpen.toString());
      mobileNav.setAttribute('aria-hidden', (!isOpen).toString());
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });

    // Close on outside click
    document.addEventListener('click', function (e) {
      if (!mobileNav.contains(e.target) && !mobileToggle.contains(e.target)) {
        mobileNav.classList.remove('is-open');
        mobileToggle.setAttribute('aria-expanded', 'false');
        mobileNav.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    });
  }

  // ── Cart AJAX Add ───────────────────────────────────────────────
  const addToCartForms = document.querySelectorAll('form[action*="cart/add"]');

  addToCartForms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      const formData = new FormData(form);
      const submitBtn = form.querySelector('[type="submit"]');

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.style.opacity = '0.7';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart add failed');
          return response.json();
        })
        .then(function () {
          // Update cart count
          return fetch('/cart.js');
        })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          const cartCount = document.querySelector('.header__cart-count');
          if (cartCount) {
            cartCount.textContent = cart.item_count;
            cartCount.style.display = cart.item_count > 0 ? 'flex' : 'none';
          } else if (cart.item_count > 0) {
            const cartLink = document.querySelector('.header__cart-link');
            if (cartLink) {
              const badge = document.createElement('span');
              badge.className = 'header__cart-count';
              badge.textContent = cart.item_count;
              cartLink.appendChild(badge);
            }
          }

          // Visual feedback
          if (submitBtn) {
            const originalContent = submitBtn.innerHTML;
            submitBtn.innerHTML = 'In winkelkar';
            submitBtn.style.backgroundColor = '#16a34a';
            setTimeout(function () {
              submitBtn.innerHTML = originalContent;
              submitBtn.style.backgroundColor = '';
              submitBtn.disabled = false;
              submitBtn.style.opacity = '';
            }, 1500);
          }
        })
        .catch(function (err) {
          console.error('Cart error:', err);
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.style.opacity = '';
          }
        });
    });
  });

  // ── Announcement Bar ────────────────────────────────────────────
  // Marquee effect for announcement bar if text is long
  const announcementBar = document.querySelector('.announcement-bar__message');
  if (announcementBar && announcementBar.scrollWidth > announcementBar.clientWidth) {
    announcementBar.style.animation = 'marquee 20s linear infinite';
  }

  // ── Lazy Load Images ────────────────────────────────────────────
  if ('IntersectionObserver' in window) {
    const lazyImages = document.querySelectorAll('img[loading="lazy"]');
    const imageObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          const img = entry.target;
          imageObserver.unobserve(img);
        }
      });
    });

    lazyImages.forEach(function (img) {
      imageObserver.observe(img);
    });
  }

  // ── Smooth Scroll for Anchor Links ─────────────────────────────
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      const targetId = this.getAttribute('href').slice(1);
      const target = document.getElementById(targetId);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('[name="add"]');
    if (btn) {
      btn.closest('form').addEventListener('submit', function() {
        setTimeout(function() {
          window.location.href = '/cart';
        }, 800);
      });
    }
  });
});